
import styled from "styled-components"
import question from "../../../images/svg/question.svg"
import Btn from "../button/Btn"
import { useRef } from "react"

const Container = styled.div`
    width: ${({width}) => width};
    height: ${({height, autoHeight}) => autoHeight ? autoHeight : height};
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    

    .top-container{
        width: 100%;
        height: 40px;
        background-color: var(--color-main);
        color: #fff;
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        
        h4{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }        
    }

    .doc-container{
        width: 100%;
        height: calc(100% - 80px);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 !important;

        img{
            width: 100%;
            max-width: 100%;
            overflow: auto;
            object-fit: cover;
        }
    }

    .bottom-container{
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        padding: 0 10px;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};


            .delete-btn{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                width: 80px;
                padding: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                cursor: pointer;
                border: 1px solid var(--color-main);
                color: var(--color-main);
            }

            
            .file-input-label{
                width: 80px;
                background-color: var(--color-main);
                padding: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 10px;
                cursor: pointer;
                color: #fff;
            }

            .file-input{
                display: none;
            }

        }

`


const DocItem = ({givenDoc, title, doc, setDoc, width, height="300px", name, isCompany}) => {

    const fileInputRef = useRef(null);
    return (
    <Container autoHeight={(givenDoc || doc) && "auto"} width={width} height={height}>
        <div className="top-container">
            <h4>{title}</h4>
        </div>
        <div className="doc-container">
            {
                isCompany ? 
                <img src={(doc && doc !== undefined) ? URL?.createObjectURL(doc) : givenDoc ? `${process.env.REACT_APP_API_IMG_COMPANY_URI}${givenDoc}` : question} className="belge-img" alt={title} />
                :
                <img src={(doc && doc !== undefined) ? URL?.createObjectURL(doc) : givenDoc ? `${process.env.REACT_APP_API_IMG_URI}${givenDoc}` : question} className="belge-img" alt={title} />
            }
        </div>

        <div className="bottom-container">
            {/* <span className="doc-name">{doc.name?.length > 25 ? `${doc.name.substring(0, 25)}...` : doc.name}</span> */}
                {
                    doc ?
                    <button className="delete-btn" onClick={() => {setDoc({value: "", name: name}); fileInputRef.current.value = null}}>Sil</button>
                    :
                    <label className="file-input-label" htmlFor={title}>Seç</label>
                }
                <input accept=".jpg,.jpeg,.png" type="file" id={title} className='file-input' ref={fileInputRef} onChange={(e) => setDoc({value: e.target.files[0], name: name})} />
        </div>
    </Container>
  )
}

export default DocItem